/*
  AlchePharma lightbox fix (2026-10-22)
  Problem: the StarApps Variant Image app rebuilds the product gallery after the
  theme has attached its Fancybox click handlers. The rebuilt links keep the
  "fancybox-initialized" class but lose the handler, so a click opens the raw
  image file instead of the zoom lightbox.
  Fix: one delegated click handler (capture phase) that opens the theme's own
  Fancybox for any a[data-fancybox] link, old or rebuilt. It reuses the theme's
  functions from custom-async.js, and falls back to the theme default if they
  are missing.
*/
(function () {
  if (window.__apLightboxFix) return;
  window.__apLightboxFix = true;

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-fancybox]') : null;
    if (!a) return;
    var name = a.getAttribute('data-fancybox');
    if (!name) return;
    if (typeof window.requestFancyboxPlugin !== 'function' ||
        typeof window.createFancyboxAndShowItem !== 'function') return; // theme default

    e.preventDefault();
    e.stopPropagation();

    window.requestFancyboxPlugin(function () {
      if (!a.isConnected) return;
      var list = document.querySelectorAll('[data-fancybox="' + name + '"]');
      var idx = Array.prototype.indexOf.call(list, a);
      if (idx < 0) return;
      if (a.getAttribute('data-zoom') === 'false') {
        document.documentElement.classList.add('fb-no-zoom');
      }
      if (typeof window.bindModelViewerClickBlock === 'function') {
        window.bindModelViewerClickBlock(name);
      }
      // fp is a top-level const in the theme (not on window), so use the bare name.
      if (typeof window.new_css === 'function' && typeof fp === 'function') {
        window.new_css('css-fancybox', fp('styles/async-fancybox.css', 'async_fancybox_css'));
      }
      window.createFancyboxAndShowItem(idx, name);
    });
  }, true);
})();
